import React from "react";
import "./dot.css";

export const VIPDot = () => {
  return <span class="blink_vip"></span>;
};

export const PoliticalDot = () => {
  return <span class="blink_political"></span>;
};
